import InvoiceDashboardPreview from './DashboardPreview';

export default InvoiceDashboardPreview;
